<template>
    <div>
        <v-app-bar
            :app="!$root.edit || !$store.state.editMenu"
            :prominent="reallyProminent"
            :color="transparent ? 'transparent' : backgroundColor"
            :hide-on-scroll="hideOnScroll"
            v-if="!$root.mobilePreview && !$root.revisionPreview"
            :flat="transparent"
            :src="transparent ? undefined : $api.getImageUrl(backgroundImage)"
        >
            <div class="d-flex align-center" style="height: 90%; cursor: pointer" @click="$root.edit ? undefined : goto('/')">
                <img v-if="logo"
                     alt="Logo"
                     class="z-page-logo"
                     :src="$api.getImageUrl(logo, 400)"
                />
            </div>

            <v-row
                :justify="reallyProminent ? 'center' : undefined"
                :align="reallyProminent ? 'center' : undefined"
                :class="appBarRowClasses"
                :key="menuKey"
            >
                <v-col cols="12" :class="'d-flex' + ' ' + justify">

                    <draggable v-model="$root.siteconfig.buttons" @change="$root.saveHomePage()" :disabled="!$root.edit" group="menuitem" tag="ContentsContainer">
                        <component-wrapper
                            v-for="(button, buttonIndex) in visibleMenuItems"
                            :key="button.id"
                            :config="button"
                            class="d-inline-block"
                            can-remove
                            v-on:remove="removeMenuItem(buttonIndex)"
                            v-on:addsubmenuitem="showAddMenuItemDialog(buttonIndex)"
                        />
                    </draggable>

                </v-col>
            </v-row>

            <v-spacer></v-spacer>

            <div class="d-flex fill-height align-center">
                <v-fab-transition v-if="$root.edit">
                    <v-btn class="hidden-sm-and-down mx-2" @click.stop="showAddMenuItemDialog(null)" fab small color="zoezi-edit-color">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-fab-transition>

                <component-wrapper
                    v-if="rightComponent"
                    :config="rightComponent"
                />
            </div>

        </v-app-bar>

        <!-- <v-navigation-drawer
      :value="$store.state.showMobileMenu"
      @input="$store.commit('setShowMobileMenu', $event)"
      disable-route-watcher
      disable-resize-watcher
      app
      :right="true"
      :width="fullWidth ? '100%' : ''"
      :color="backgroundColor"
      :src="transparent ? undefined : $api.getImageUrl(backgroundImage)"
      hide-overlay
      style="z-index: 5; bottom: 0px"
      height="300px"
    >
      <v-row>
        <v-col cols="12" style="height: 40px">
          <v-btn right fixed icon @click="$store.commit('setShowMobileMenu', false)" :color="color"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-list
        nav
        dense
      >
        <v-list-item-group>
           <component-wrapper
              v-for="(button, buttonIndex) in visibleMenuItems"
              :key="button.id"
              :config="button"
              can-remove
              v-on:remove="removeMenuItem(buttonIndex)"
              v-on:addsubmenuitem="showAddMenuItemDialog(buttonIndex)"
            />

            <component-wrapper
              v-if="rightComponent"
              :config="rightComponent"
            />
        </v-list-item-group>

      </v-list>
     </v-navigation-drawer> -->

        <v-dialog
            v-model="showAddMenuItem"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">{{$translate('Add new menu option')}}</v-card-title>

                <v-card-text class="pt-4">
                    <v-text-field :label="$translate('Title')" v-model="newMenuItem.title" @input="updateNewPageLink()" color="zoezi-edit-color" />

                    <v-text-field :label="$translate('Link')" v-model="newMenuItem.path" color="zoezi-edit-color" v-if="newMenuItem.addPage" />
                    <zoezi-autocomplete v-else :label="$translate('Link')" :items="sortedRoutes" item-text="name" item-value="path" v-model="newMenuItem.path" />

                    <v-switch :label="$translate('Add new page')" v-model="newMenuItem.addPage" color="zoezi-edit-color" @change="addPageChanged" />

                    <template v-if="newMenuItem.addPage">
                        <h3>{{$translate('Select page template for new page')}}</h3>
                        <page-template-palette v-model="newMenuItem.page" />
                    </template>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="zoezi-edit-color"
                        :disabled="!newMenuItemValid"
                        @click="addNewMenuItem"
                    >
                        {{$translate('Add')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import PageTemplatePalette from '../components/PageTemplatePalette.vue'
import ZoeziAutocomplete from '../components/ui/form/Autocomplete.vue'
import components from '../component.js';
import { addRoute } from '../router.js'
import { isValidPath, makeValidPathFromTitle } from '../util.js'
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'

export default {
    name: 'zoezi-appbar',

    zoezi: {
        title: 'Menubar',
        icon: 'mdi-menu'
    },

    props: {
        logo: {
            title: 'Logo',
            type: String,
            fulltype: 'image'
        },
        backgroundColor: {
            title: 'Background color',
            type: String,
            fulltype: 'color'
        },
        color: {
            title: 'Text color',
            type: String,
            fulltype: 'color'
        },
        activeColor: {
            title: 'Color of selected menu option',
            type: String,
            fulltype: 'color'
        },
        prominent: {
            title: 'High menu bar',
            type: Boolean
        },
        hideOnScroll: {
            title: 'Hide menu on scroll',
            type: Boolean
        },
        backgroundImage: {
            title: 'Background image',
            type: String,
            fulltype: 'image'
        },
        transparent: {
            title: 'Transparent menu bar',
            type: Boolean
        },
        uppercase: {
            title: 'Capital letters in the menu',
            type: Boolean
        },
        fullWidth: {
            title: 'Full width for menu on mobile',
            type: Boolean
        },
        showCheckinButton: {
            title: 'Show button for Check-in on mobile',
            type: Boolean,
            default: true
        },
        showStaffButton: {
            title: 'Show staff page button on mobile',
            type: Boolean,
            default: true
        },
        checkinResources: {
            title: 'Resources to be displayed at mobile check-in',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                clearable: true,
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all resources',
                getItems: () => window.$zoeziapi.get('/api/door/get', {site_id: this.$store.state.selectedSiteId})
            },
            default: () => []
        },
        justify: {
            title: 'Menu button placement',
            type: String,
            fulltype: 'alignment'
        },
        rightComponent: {
            title: 'Component to the right',
            type: Object,
            fulltype: 'component',
            typeinfo: {
                clearable: true
            },
            default: () => components.makeEmptyConfig({component: 'zoezi-account-button'})
        }
    },

    components: {
        Draggable,
        PageTemplatePalette,
        ZoeziAutocomplete,
    },

    data: () => ({
        showAddMenuItem: false,
        menuKey: 0,
        newMenuItem: {
            title: '',
            addPage: true,
            submenu: null,
            path: '/',
            page: {}
        }
    }),
    computed: {
        sortedRoutes() {
            return this.$root.siteconfig.routes.map(r => r.props).sort((a, b) => a.name.localeCompare(b.name));
        },
        newMenuItemValid() {
            return this.newMenuItem.title.length && this.newMenuItem.path.length && isValidPath(this.newMenuItem.path) && (!this.newMenuItem.addPage || (!this.$root.siteconfig.routes.find(x => x.props.path == this.newMenuItem.path) && this.newMenuItem.page.config && this.newMenuItem.page.config.component))
        },
        visibleMenuItems() {
            return this.$root.siteconfig.buttons;
        },
        reallyProminent() {
            return this.prominent && !this.$vuetify.breakpoint.mobile;
        },
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
        appBarRowClasses() {
            const classes = ['hidden-sm-and-down'];
            if (this.reallyProminent) {
                classes.push('fill-height');
            }
            if (this.homepageFixHorizontalScrollEnabled) {
                classes.push('z-appbar-row');
            }
            return classes;
        }
    },
    watch: {
        '$vuetify.breakpoint.mobile'(mobile) {
            if (!mobile) {
                this.$store.commit('setShowMobileMenu', false);
            }
        }
    },
    methods: {
        removeMenuItem(buttonIndex) {
            this.$root.siteconfig.buttons.splice(buttonIndex, 1);
            this.$root.saveHomePage();
            this.menuKey++;
        },
        addNewMenuItem() {
            let newitem = components.makeEmptyConfig({component: 'zoezi-menuitem', props: {link: this.newMenuItem.path, title: this.newMenuItem.title, subitems: [] }});
            let array = this.newMenuItem.submenu === null ? this.$root.siteconfig.buttons : this.$root.siteconfig.buttons[this.newMenuItem.submenu].props.subitems;
            array.splice(array.length, 0, newitem);
            components.addNewComponent(newitem);

            this.showAddMenuItem = false;

            if (this.newMenuItem.addPage) {
                // FIXME: Set id's here?
                let config = this.newMenuItem.page.config;
                config = components.makeEmptyConfig({component: 'zoezi-page', props: {config: config, name: this.newMenuItem.title, path: this.newMenuItem.path}})
                addRoute(config, this.$router);

                this.$root.siteconfig.routes.push(config);
                this.$router.push({path: config.props.path});
            }

            this.$root.saveHomePage();
        },
        updateNewPageLink() {
            if (this.newMenuItem.addPage) {
                this.newMenuItem.path = makeValidPathFromTitle(this.newMenuItem.title);
            }
        },
        showAddMenuItemDialog(submenu) {
            Object.assign(this.newMenuItem, {title: '', addPage: true, submenu: submenu, path: '/', page: {}});
            this.showAddMenuItem = true;
        },
        addPageChanged() {
            if (!this.newMenuItem.addPage) {
                this.newMenuItem.path = '/';
            } else {
                this.updateNewPageLink();
            }
        },
        goto(link) {
            if (this.$route.path != link) {
                this.$router.push({path: link});
            }
        }
    }
}
</script>
